import Vue from "@/main";
import { Message } from "element-ui";
import { set } from "lodash";
import proj4 from "proj4";
import * as modelMap from "@/views/index/map.js";

export let graphicLayer; // 矢量图层对象

export function createdGraphicLayer() {
  graphicLayer = new mars3d.layer.GraphicLayer();
  if (Vue.$GLOBAL.map.addLayer) {
    Vue.$GLOBAL.map.addLayer(graphicLayer);
  } else {
    setTimeout((res) => {
      createdGraphicLayer();
    }, 1000);
  }
}

let redColor = "red"; //施工区
let blueColor = "blue"; //上行
let greenColor = "green"; //下行

export function startDrawGraphic(positions) {
  positions.forEach((el) => {
    el.push(30);
  });
  const graphic = new mars3d.graphic.PolylineEntity({
    positions: positions,
    style: {
      width: 5,
      color: "#3CB371",
      label: { text: "", pixelOffsetY: -30 },
      // 高亮时的样式（默认为鼠标移入，也可以指定type:'click'单击高亮），构造后也可以openHighlight、closeHighlight方法来手动调用
      highlight: {
        color: "#ff0000",
      },
    },
  });
  graphicLayer.addGraphic(graphic);
}
//绘制线
export function addDemoGraphic(item) {
  let color = "";
  let materialType = "LineBloom";
  if (item.type == "下行行车") {
    color = greenColor;
    item.detail = item.detail.sort(function(a, b) {
      return b.sort - a.sort;
    });
    materialType = "LineBloom";
  } else if (item.type == "上行行车") {
    color = blueColor;
    materialType = "LineBloom";
  } else if (item.type == "施工区") {
    color = redColor;
    materialType = "Color";
  } else {
    color = "#000000";
  }

  let positions = [];
  let positions2 = [];
  let Z;

  let distanceDisplayCondition_far, distanceDisplayCondition_near;
  if (item.Level == 1) {
    distanceDisplayCondition_far = 6000;
    distanceDisplayCondition_near = 0;
    Z = 30;
  } else if (item.Level == 2) {
    distanceDisplayCondition_far = 10000;
    distanceDisplayCondition_near = 6000;
    Z = 60;
  } else if (item.Level == 3) {
    distanceDisplayCondition_far = 100000;
    distanceDisplayCondition_near = 10000;
    Z = 100;
  }

  item.detail.forEach((element) => {
    if (item.type == "施工区") {
      positions2.push([element.x, element.y, Z]);
    } else {
      positions.push([element.x, element.y, Z]);
    }
  });
  // return;
  const graphic = new mars3d.graphic.PolylineEntity({
    positions: positions,
    type: "polyline",
    style: {
      width: item.roadWidth,
      clampToGround: false,
      distanceDisplayCondition: true,
      distanceDisplayCondition_far: distanceDisplayCondition_far,
      distanceDisplayCondition_near: distanceDisplayCondition_near,
      // materialType: mars3d.MaterialType.LineFlow,
      materialType: materialType,
      materialOptions: {
        color: color,
        opacity: 0.8,
        // speed: 10,
        // repeat_x: 30,
        // tag: "dynamicArrowCoarse",
        // image: "/img/textures/lineArrow2.png",
        glow: 1,
        materialType: materialType,
        speed: 5,
      },
      // label: {
      //   text: item.identity,
      //   pixelOffsetY: -30,
      // },
      // 高亮时的样式（默认为鼠标移入，也可以指定type:'click'单击高亮），构造后也可以openHighlight、closeHighlight方法来手动调用
      // highlight: {
      //   color: "#ff0000",
      // },
    },
  });
  graphicLayer.addGraphic(graphic);

  const graphic2 = new mars3d.graphic.PolylineEntity({
    positions: positions2,
    style: {
      width: item.Level == 3 ? 2 : item.Level == 2 ? 4 : 8,
      color: redColor,
      distanceDisplayCondition: true,
      distanceDisplayCondition_far: distanceDisplayCondition_far,
      distanceDisplayCondition_near: distanceDisplayCondition_near,
      scaleByDistance: false,
    },
  });
  graphicLayer.addGraphic(graphic2);

  //标记
  // const graphic = new mars3d.graphic.BillboardEntity({
  //   position: new mars3d.LngLatPoint(116.5, 30.9, 1000),
  //   style: {
  //     image: "img/marker/markffd700.png",
  //     scale: 1,
  //     horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
  //     verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
  //   },
  //   attr: { remark: "停车区" },
  // });
  // graphicLayer.addGraphic(graphic);
}

export function reset() {
  if (graphicLayer) graphicLayer.clear();
}

export function getData(x, y, z) {
  // 当前项目的proj4
  const fromProjection = `PROJCS["CGCS2000_3_Degree_GK_CM_114E",GEOGCS["GCS_China_Geodetic_Coordinate_System_2000",DATUM["D_China_2000",SPHEROID["CGCS2000",6378137.0,298.257222101]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["central_meridian",113.75],PARAMETER["false_easting",500000],PARAMETER["false_northing",0],PARAMETER["latitude_of_origin",0],PARAMETER["scale_factor",1],UNIT["metre",1]]`;

  // const fromProjection = `PROJCS["<Custom Projection Coordinate System>",GEOGCS["duyun-10740-900",DATUM["<Custom>",SPHEROID["IAG 1975",6379040,298.257],TOWGS84[-0.905,3.434,1.711,0.571304,-1.284269,3.3371,-0.145978]],PRIMEM["Greenwich",0],UNIT["degree",0.0174532925199433]],PROJECTION["Gauss_Kruger"],PARAMETER["central_meridian",107.666666667],PARAMETER["false_easting",500000],PARAMETER["false_northing",0],PARAMETER["latitude_of_origin",0],PARAMETER["scale_factor",1],UNIT["metre",1]]`;

  //   const fromProjection = `PROJCS["Transverse_Mercator",GEOGCS["GCS_泉夏118度21分",DATUM["D_泉夏118度21分",SPHEROID["CGCS2000",6378137,298.257222101]],PRIMEM["Greenwich",0],UNIT["Degree",0.017453292519943295]],PROJECTION["Transverse_Mercator"],PARAMETER["scale_factor",1],PARAMETER["central_meridian",118.35],PARAMETER["latitude_of_origin",0],PARAMETER["false_easting",500000],PARAMETER["false_northing",0],UNIT["Meter",1]]
  // `;
  // const fromProjection = `PROJCS["<Custom Projection Coordinate System>",GEOGCS["duyun-10740-900",DATUM["<Custom>",SPHEROID["IAG 1975",6379040,298.257]],PRIMEM["Greenwich",0],UNIT["degree",0.0174532925199433]],PROJECTION["Gauss_Kruger"],PARAMETER["central_meridian",107.666666667],PARAMETER["false_easting",500000],PARAMETER["false_northing",0],PARAMETER["latitude_of_origin",0],PARAMETER["scale_factor",1],UNIT["metre",1]]`;

  let arr = [Number(x), Number(y), 50];

  // 固定WGS84
  const toProjection = `GEOGCS["WGS 84",DATUM["WGS_1984",SPHEROID["WGS 84",6378137,298.257223563,AUTHORITY["EPSG","7030"]],
                                  AUTHORITY["EPSG", "6326"]], PRIMEM["Greenwich", 0, AUTHORITY["EPSG", "8901"]],
                                  UNIT["degree", 0.0174532925199433, AUTHORITY["EPSG", "9122"]], AUTHORITY["EPSG", "4326"]]`;

  // proj4存在
  if (fromProjection) {
    // 转换出坐标
    const proj4List = proj4(fromProjection, toProjection, arr);
    // proj4List.push(300);
    // console.log(proj4List);
    // Vue.$GLOBAL.map.flyToPositions([proj4List]);
    return proj4List;
  }
}

export function getData2(x, y, z) {
  // let arr = [[474881.835, 2888405.9601]];

  // let arr2 = [];
  // arr.forEach((el) => {
  //   var a = mars3d.PointTrans.proj4Trans(
  //     [el[0], el[1], 200],

  //     "+proj=tmerc +lat_0=0 +lon_0=107.666666667 +k=1 +x_0=500000 +y_0=0 +a=6379040 +rf=298.257 +units=m +no_defs",
  //     mars3d.CRS.EPSG4326
  //   );

  //   arr2.push(a);
  // });
  // console.log(JSON.stringify(arr2));
  // Vue.$GLOBAL.map.flyToPositions(arr2);
  Vue.$GLOBAL.map.setCameraView({
    lat: 26.1005594964545,
    lng: 107.416716354317,
    alt: 1000,
    heading: 0,
    pitch: -45,
  });
  const graphic = new mars3d.graphic.PointEntity({
    name: "根据视距显示点",
    position: new mars3d.LngLatPoint(107.416716354317, 26.1005594964545, 1000),
    style: {
      color: "#0000ff",
      pixelSize: 20,
      outlineColor: "#ffffff",
      outlineWidth: 2,
    },
    attr: { remark: "示例4" },
  });
  graphicLayer.addGraphic(graphic);
}

/**
 *
 * 初始化
 * @returns { any }
 */
export function init(modelId, list, type) {
  let color;
  let isComponent = false;
  let isComponent_cc = false;
  let map = Vue.$GLOBAL.map;
  // model = map.getLayer(modelId, "modelId");

  console.log(list, "listlistlistlistlist");
  model.style = undefined;
  return;
  model.style = (event) => {
    console.log(type, "typetype");
    if (type == "新建") {
      try {
        list.forEach((e) => {
          // var str = event.feature.getProperty("name");
          // var index = str.substring(str.indexOf("-") + 1, str.length);
          // if (index.split("@")[0] == e) throw new Error();
          if (event.feature.getProperty("name").indexOf(e) >= 0)
            throw new Error();
        });
      } catch (err) {
        isComponent_cc = true;
      }
      // } else if (type == "拆除") {
    } else {
      color = "rgba(255,255,255,1)";
      // console.log(555555555555);
      // try {
      //   list.forEach((e) => {
      //     // var str = event.feature.getProperty("name");
      //     // var index = str.substring(str.indexOf("-") + 1, str.length);
      //     // if (index.split("@")[0] == e) throw new Error();
      //     if (event.feature.getProperty("name").indexOf(e) >= 0)
      //       throw new Error();
      //   });
      // } catch (err) {
      //   isComponent = true;
      // }
    }

    //保留
    // if (isComponent) {
    //   console.log(6666666666666);
    //   color = "rgba(255,255,255,1)";
    // }
    if (isComponent_cc) {
      color = "rgba(255,255,255,0)";
    }

    return color;
  };
}

//纯染色方法
let counter = 0;
let model;
export let componentDyeing = _.debounce((data, modelId, destroy) => {
  let map = Vue.$GLOBAL.map;
  model = map.getLayer(modelId, "modelId");
  console.log(data, "data--------data------data");

  model.style = (event) => {
    counter += 0.0004;
    // color = "rgba(42, 183, 255)";
    color = "rgba(255,255,255,1)";

    let color = "";
    let isTransitionComponent = false;
    let isComponent = false;
    let isComponent_cc = false;
    let isTransitionComponent_cc = false;

    if (!destroy) {
      //进入某一块
      try {
        data.newList.forEach((e) => {
          var str = event.feature.getProperty("name");
          var index = str.substring(str.indexOf("-") + 1, str.length);
          if (index.split("@")[0] == e) throw new Error();

          // if (event.feature.getProperty("name").indexOf(e) >= 0)
          //   throw new Error();
        });
      } catch (err) {
        isTransitionComponent = true;
      }

      try {
        data.deleteList.forEach((e) => {
          var str = event.feature.getProperty("name");
          var index = str.substring(str.indexOf("-") + 1, str.length);
          if (index.split("@")[0] == e) throw new Error();

          // if (event.feature.getProperty("name").indexOf(e) >= 0)
          //   throw new Error();
        });
      } catch (err) {
        isTransitionComponent_cc = true;
      }
    } else {
      //离开某一块
      try {
        console.log(data, "data.component**********");
        data.delete_finish_List.forEach((e) => {
          var str = event.feature.getProperty("name");
          var index = str.substring(str.indexOf("-") + 1, str.length);
          if (index.split("@")[0] == e) throw new Error();

          // if (event.feature.getProperty("name").indexOf(e) >= 0)
          //   throw new Error();
        });
      } catch (err) {
        isComponent_cc = true;
      }

      try {
        console.log(data, "data.component**********");
        data.new_finish_List.forEach((e) => {
          var str = event.feature.getProperty("name");
          var index = str.substring(str.indexOf("-") + 1, str.length);
          if (index.split("@")[0] == e) throw new Error();

          // if (event.feature.getProperty("name").indexOf(e) >= 0)
          //   throw new Error();
        });
      } catch (err) {
        isComponent = true;
      }
    }

    //蓝色
    if (isTransitionComponent) {
      color = "rgba(63, 75, 243,1)";
    }
    //红色
    if (isTransitionComponent_cc) {
      color = "rgba(255,0,0,1)";
    }
    //拆除
    if (isComponent_cc) {
      color = "rgba(255,255,255,0)";
    }
    //保留
    if (isComponent) {
      color = "rgba(255,255,255,1)";
    }

    return color;
  };
}, 0);
